import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { CTABannerSection } from '../components/CTABannerSection';
import { TrustSection } from '../components/TrustSection';
import { TipsSection } from '../components/TipsSection';
import { ServiceProcessSection } from '../components/ServiceProcessSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactCTASection } from '../components/ContactCTASection';
export function HomePage() {
  return <div data-id="element-813">
      <HeroSection data-id="element-814" />
      <IntroSection data-id="element-815" />
      <ServicesSection data-id="element-816" />
      <WhyChooseUsSection data-id="element-817" />
      <CTABannerSection data-id="element-818" />
      <TrustSection data-id="element-819" />
      <TipsSection data-id="element-820" />
      <ServiceProcessSection data-id="element-821" />
      <TestimonialsSection data-id="element-822" />
      <ContactCTASection data-id="element-823" />
    </div>;
}